// extracted by mini-css-extract-plugin
module.exports = {"tourAlertWrapper":"TourAlert_tourAlertWrapper__0kL_x"};